import Role from "../../lib/Role";

/**
 * @return {boolean}
 */
function HasAdminRole(loggedInUser) {
    const allowedRoles = [Role.ADMIN];
    return allowedRoles.indexOf(loggedInUser.role) >= 0;
}
export default HasAdminRole;